<!--
 * @Description: 密码修改页
 * @Author: ma.cq
 * @LastEditors: ma.cq
 * @Date: 2019-04-17 14:23:42
 * @LastEditTime: 2019-04-18 09:31:17
 -->
<template>
  <div class="change-psw">
    <el-form :model="form" ref="form" :rules="formRules" label-width="100px">
      <el-form-item label="旧密码" prop="oldPsw">
        <PswInput class="input-width-200" v-model="form.oldPsw"/>
      </el-form-item>
      <el-form-item required label="新密码" placeholder="密码至少8位并含有大写字母、小写字母、数字、特殊符号" prop="newPsw">
        <PswInput class="input-width-200" v-model="form.newPsw"/>
      </el-form-item>
      <el-form-item required label="确认新密码" prop="vNewPsw">
        <PswInput class="input-width-200" v-model="form.vNewPsw"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">确认修改</el-button>
        <el-button @click="goBack">取 消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { checkCode } from '@/common/verify'
import PswInput from '@/components/pswInput'

export default {
  name: 'changePsw',
  components: { PswInput },
  data () {
    const validateOldPsw = (rule, value, cb) => {
      this.checkOldPsw(this.form).then(res => {
        if (!res) {
          cb(new Error('旧密码输入错误，请重新输入'))
        } else {
          cb()
        }
      })
    }
    const validateNewPsw = (rule, value, cb) => {
      if (value === '') {
        cb(new Error('新密码不能为空'))
      } else {
        if (this.form.vNewPsw !== '') {
          this.$refs['form'].validateField('vNewPsw')
        }
        cb()
      }
    }
    const validateNewPsw2 = (rule, value, cb) => {
      if (value === '') {
        cb(new Error('请再次输入密码'))
      } else if (value !== this.form.newPsw) {
        cb(new Error('两次输入密码不一致!'))
      } else {
        cb()
      }
    }
    return {
      form: {
        oldPsw: '',
        newPsw: '',
        vNewPsw: ''
      },
      formRules: {
        oldPsw: [
          { required: true, message: '旧密码不能为空' },
          // { pattern: checkCode, message: '旧密码格式有误，请重新输入' },
          { validator: validateOldPsw, trigger: 'blur' }
        ],
        newPsw: [
          { validator: validateNewPsw },
          { pattern: checkCode, message: '至少8位并含有大写字母、小写字母、数字、特殊符号' }
        ],
        vNewPsw: [
          { validator: validateNewPsw2 }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['logout', 'checkOldPsw', 'changePsw']),
    onSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.changePsw(this.form).then(() => {
            this.logout().then(() => {
              this.$router.replace('/login')
              // this.$router.go(0) //  清store
            })
          })
        } else {
          return false
        }
      })
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.input-width-200{
  width: 200px;
}
</style>
